import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateCityPayload {
  province_id: number;
  code: string;
  name: string;
  status: number;
}

export interface UpdateCityPaylod extends CreateCityPayload {}

export const CITY_QUERY_KEY = ["city"];
export const VIEW_CITY_QUERY_KEY = ["view-city"];

export const cityService = {
  createCity: async (payload: CreateCityPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/city", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showCity: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/city/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateCity: async (id: number, payload: UpdateCityPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/city/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/city/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  getAllCities: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-city`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getCityByProvince: async (id: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/city/${id}/by-province`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
